import type { LocationDescriptor } from 'history';

export interface RelatedLinksItem {
  label: string;
  link: LocationDescriptor;
}

export interface RelatedLinksCategory {
  label: string;
  items: RelatedLinksItem[];
}

export interface RelatedLinksData {
  categories: RelatedLinksCategory[];
}

export interface RelatedLinksProps extends RelatedLinksData {}
